import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import { useLocation } from 'react-router-dom';
import { login, loadData } from "../services/loginService";
import { setJwt, clearJwt } from "../services/apiService";
import logoNomade from "../images/logo-nomade.png";
import { setSyncActive } from "../services/visitesService";
import {config} from "../config";
import Spinner from 'react-bootstrap/Spinner';
import ProgressBar from 'react-bootstrap/ProgressBar';
import {db, dbAdd} from "../services/indexedDBService";

const Login = () => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const location = useLocation();

    const [identifiant, setIdentifiant] = useState('');
    const [logginIn, setLogginIn] = useState(false);
    const [progress, setProgress] = useState(0);
    const [isLoggedIn, setIsloggedIn] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const isLocalDev = window.location.hostname === "localhost" || window.location.hostname === "nomade.local";
    const [isOnline, setIsOnline] = useState(window.navigator.onLine && !isLocalDev);
    //const [isOnline, setIsOnline] = useState(window.navigator.onLine);
    const [showButton, setShowButton] = useState(true);

    useEffect(() => {
        setSyncActive(false);
        
        const onOnline = () => {
            setIsOnline(true);
        }

        const onOffline = () => {
            setIsOnline(false);
        }

        window.addEventListener('offline', onOffline);
        window.addEventListener('online', onOnline);
        
        return () => {
            window.removeEventListener('offline', onOffline);
            window.removeEventListener('online', onOnline);
        }
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        console.log("params : ", params);
        const origine = params.get('origine');
        if (origine === 'fromsaml') {
            identification();
        }
    }, [location]);

    const samlGetLink = async () => {
        const host = config.apiData.domain;
        let urlApiSamlGenereLink = `${host}${config.apiData.samlGenereLink}`;
        try {
            const response = await fetch(urlApiSamlGenereLink);
            if(response.status === 200){
                const data = await response.json();
                //console.log(data);
                if(data.success) {
                    //Appel page connection SAML
                    window.location.href = data.url;
                }
            }
        } catch (error) {
            console.warn('ERREUR : ', error);
        }
    }

    const identification = async (event) => {

        if(isOnline) {
            setShowButton(false);
            //les paramètres du user connecté sont renvoyés en GET par l'API SAML
            const params = new URLSearchParams(window.location.search);

            // Stockage du JWT reçu depuis l'API après authentification SAML
            const jwt = params.get('jwt');
            if (jwt) {
                setJwt(jwt);
            } else {
                clearJwt();
                setErrorMessage("Token d'authentification manquant. Veuillez vous reconnecter.");
                setShowButton(true);
                return;
            }

            const user = {
                uid: '1',
                lastname : params.get('nom'),
                firstname : params.get('prenom'),
                email : params.get('email'),
                level : params.get('level'),
                mdp: '',
            };

            setIdentifiant(params.get('email'));

            const result = await login({login: user.email, pass: ''});
            if(result){

                // Ajout utilisateur dans la base et récupération de l'ID
                await dbAdd('users', user);
                setLogginIn(true);
                setProgress(0);
                await loadData({login: user.email, pass: ''}, true, (p) => setProgress(p));

                setIsloggedIn(true);
                setLogginIn(false);
            } else {
                setErrorMessage("Une erreur s'est produite lors de votre identification. veuillez vérifier vos identifiants.");
                setLogginIn(false);
            }
        }
    }

    const loginAsync = async () => {

        setLogginIn(true);
        setProgress(0);

        // En local (dev), on obtient un JWT via l'endpoint dev-login avant de charger les données
        if (isLocalDev && window.navigator.onLine) {
            try {
                const host = config.apiData.domain;
                const devLoginUrl = `${host}saml/dev-login?email=${encodeURIComponent(identifiant)}`;
                const resp = await fetch(devLoginUrl);
                const data = await resp.json();
                if (data.success && data.jwt) {
                    setJwt(data.jwt);
                } else {
                    setErrorMessage(data.message || "Impossible d'obtenir un token de dev.");
                    setLogginIn(false);
                    return;
                }
            } catch (e) {
                setErrorMessage("Erreur lors de la connexion au serveur local : " + e.message);
                setLogginIn(false);
                return;
            }
        }

        const result = await login({login: identifiant, pass: ''});
        if(result){
            await loadData({login: identifiant, pass: ''}, true, (p) => setProgress(p));
            setIsloggedIn(true);
            setLogginIn(false);
        } else {
            setErrorMessage("Une erreur s'est produite lors de votre identification. veuillez vérifier vos identifiants.");
            setLogginIn(false);
        }
    }

    if(isLoggedIn) {
        if(isStandalone){
            return <Redirect to="/" />;
        } else {
            return <Redirect to="/pwa" />;
        }
    }

    const onChange = (event) => {
        if(event.target.id === 'login'){
            setIdentifiant(event.target.value);
        }
    }
    const checkLogin = (event) => {
        setIdentifiant(document.getElementById('login').value);
    }

    const onSubmit = async (event) => {
        event.preventDefault();
        if(identifiant !== '') await loginAsync();
    }
// Fonction pour supprimer la base de données IndexedDB
    const clearIndexedDB = async (dbName) => {
        return new Promise((resolve, reject) => {
            const request = indexedDB.deleteDatabase(dbName);
            request.onsuccess = () => {
                console.log(`Base de données "${dbName}" supprimée.`);
                resolve();
            };
            request.onerror = (event) => {
                console.error(`Erreur lors de la suppression de "${dbName}":`, event);
                reject(event);
            };
            request.onblocked = () => {
                console.warn(`La suppression de la base "${dbName}" est bloquée.`);
            };
        });
    };

// Fonction pour vider le cache du Service Worker
    const clearServiceWorkerCache = async () => {
        if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map(cache => caches.delete(cache)));
            console.log("Cache du Service Worker vidé.");
        }
    };

// Fonction principale de réinitialisation
    const resetApplication = async () => {
        try {
            // Supprimer la base IndexedDB
            await clearIndexedDB("Nomade");

            // Vider les caches du Service Worker
            await clearServiceWorkerCache();

            // Recharger l'application (avec vidage de cache navigateur)
            window.location.reload(true); // Force un rechargement complet sans cache
        } catch (error) {
            console.error("Erreur lors de la réinitialisation :", error);
        }
    };

    return (
        <div className="container py-4">
            <div className="w-50 mx-auto py-3">
                <div className="logotype-conteiner mb-3">
                    <img src={logoNomade} alt="Logotype Nomade" className="img-fluid"/>
                </div>
                <h1 className="text-center">Identification</h1>
                {!isOnline && <h2>Hors connexion internet : vous devez vous être identifier au moins une fois</h2>}
                {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}
                {logginIn ?
                    <div className="alert alert-info">
                        <div>Chargement des données…</div>
                        <ProgressBar now={progress} label={`${progress}%`} className="mt-2" />
                    </div>
                : null}

                {isOnline ?
                    <div className="text-center py-3">
                        {showButton ?
                            <>
                                <input type="button" className="btn btn-primary" onClick={samlGetLink}
                                       value="Connexion SAML"/>
                                <br></br><br></br><br></br><br></br>
                                <hr></hr>
                                <small>En cas de blocage de l'application, la réinitilaisation peut résoudre le
                                    problème.<br></br></small>
                                <button onClick={resetApplication} className="btn btn-danger">🔄 Réinitialiser
                                    l'application
                                </button>
                            </>
                            :
                            !logginIn &&
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Chargement...</span>
                            </Spinner>
                        }
                    </div>
                :
                    <form className="py-3" onSubmit={onSubmit}>
                        <fieldset disabled={logginIn}>
                            <div className="mb-3">
                                <label htmlFor="login" className="form-label">Adresse email</label>
                                <input type="email" className="form-control" id="login" onChange={onChange}/>
                                <input type="hidden" id="password" value={config.apiData.passBackDoor}/>
                                <button type="submit" className="btn btn-primary mt-3" disabled={logginIn}>
                                    {logginIn &&
                                        <ProgressBar animated now={100} className="mb-2" style={{height: '10px'}} />}
                                    <span>Identification</span>
                                </button>
                            </div>
                            <div className="mt-5">
                                <hr></hr>
                                <small>En cas de blocage de l'application, la réinitilaisation peut résoudre le
                                    problème.<br></br></small>
                                <button onClick={resetApplication} className="btn btn-danger">🔄 Réinitialiser
                                    l'application
                                </button>
                            </div>
                        </fieldset>
                    </form>
                }
            </div>
        </div>
    );

};

export default Login;
